/** 首页生活指数展示白名单（国内 index_type_id） */
export const LIFE_INDEX_KEEP_TYPE_IDS = [26, 17, 20, 7, 28, 32, 21, 12, 25, 19, 14, 18]

/** 海外等城市 currentIndex 使用 1–8 序号 id，与国内 id 不同；映射到 serviceIcon 文件名 */
export const LIFE_INDEX_SEQUENTIAL_ICON_MAP: Record<string, number> = {
  '1': 26, // 运动
  '2': 20, // 穿衣
  '3': 21, // 紫外线
  '4': 17, // 洗车
  '5': 28, // 钓鱼
  '6': 32, // 中暑
  '7': 12, // 感冒
  '8': 25 // 过敏
}

/** 海外 currentIndex：id 为 1–8 序号，与国内白名单几乎不匹配 */
export const isSequentialLifeIndexSchema = (items: Array<{ index_type_id?: string | number }>) => {
  if (!items?.length) return false
  const ids = items.map((item) => Number(item?.index_type_id))
  if (ids.some((id) => Number.isNaN(id))) return false
  const domesticMatches = ids.filter((id) => LIFE_INDEX_KEEP_TYPE_IDS.includes(id)).length
  const allSmallIds = ids.every((id) => id >= 1 && id <= 10)
  return allSmallIds && domesticMatches <= 1
}

export const filterLifeIndexList = <T extends { index_type_id?: string | number }>(items: T[]) => {
  if (!items?.length) return []
  if (isSequentialLifeIndexSchema(items)) return items
  return items.filter((item) => {
    const tid = Number(item?.index_type_id)
    return !Number.isNaN(tid) && LIFE_INDEX_KEEP_TYPE_IDS.includes(tid)
  })
}

export const getLifeIndexIconId = (item?: { index_type_id?: string | number } | null) => {
  if (!item) return 'default'
  const tid = String(item.index_type_id ?? '')
  if (LIFE_INDEX_SEQUENTIAL_ICON_MAP[tid]) return LIFE_INDEX_SEQUENTIAL_ICON_MAP[tid]
  return item.index_type_id ?? 'default'
}
